import type { ILogger } from "../../../utils/Logger/ILogger.js";
import { MarketoAllInputMeta } from "../../types/definitions/inputs/marketo-input-meta.js";
import type { AnyMarketoInputName } from "../../types/definitions/inputs/marketo-input-names-and-values.js";
import { getInputElement } from "./getInputElement.js";
import type { MarketoInputNameToHTMLElement, MarketoInputTypeByName } from "./MarketoInputNameToHTMLElement.js";

export function getMarketoInputElement<TInputName extends AnyMarketoInputName> (
  marketoFormHtmlElement: HTMLFormElement,
  inputName: TInputName,
  logger: ILogger
): MarketoInputNameToHTMLElement<TInputName> | null
{
  type TInputType = MarketoInputNameToHTMLElement<TInputName>;
  type TMarketoInputType = MarketoInputTypeByName<TInputName>;
  const expectedMarketoType = MarketoAllInputMeta[ inputName ].marketoType as TMarketoInputType;

  let inputEl: TInputType | null;
  try
  {
    inputEl = getInputElement({
      selector: `#${ inputName },*[name="${ inputName }"]`,
      inputType: expectedMarketoType,
      parentNode: marketoFormHtmlElement
    });
    if (inputEl == null)
    {
      return null;
    }

  }
  catch (err)
  {
    logger.error(`Error encountered while trying to get Marketo input element with name '${ inputName }'`, err);
    throw new Error(`Error encountered while trying to get Marketo input element with name '${ inputName }'`, { cause: err });
  }
  const isMarketoField = inputEl.matches(".mktoField");
  if (isMarketoField === false)
  {
    logger.warn(`Input ${ inputName } does not have class .mktoField`);
  }
  return inputEl as TInputType | null;
}
